import { client } from "api";
import { Office } from "models/Office";

export type GetAllOfficesResponse = Office[];

export const getAllOffices = (): Promise<GetAllOfficesResponse> =>
  client.get<GetAllOfficesResponse>(`/office/list`).then((res) => res.data);
